import ExternalLink from 'widget/components/ExternalLink';
import parseHEX from 'styles/helpers/colors/parseHEX';
import styled from '@emotion/styled';
import { ComponentProps } from 'react';
import { Theme } from 'widget/styles/themes';

const StyledExternalLink = styled(ExternalLink)<
  ComponentProps<typeof ExternalLink> & { theme?: Theme }
>(({ theme }) => {
  const { r, g, b } = parseHEX(theme.backgroundSecondary);
  return {
    ':hover': {
      backgroundColor: `rgba(${r}, ${g}, ${b}, 0.5)`,
    },
    display: 'block',
    padding: '1rem',
  };
});

export default StyledExternalLink;
